export interface ContentGridRow {
  id: string;
  date: string;
  platform: string;
  format: string;
  mediaType: "none" | "image" | "video" | "link";
  mediaUrl: string;
  copy: string;
  comments: string;
  status: "pending" | "approved" | "rejected";
  approvalCount: number;
  rejectionCount: number;
  decisionLocked: boolean;
  scheduledToCalendar: boolean;
  scheduledNetwork: string;
}

export const serializeContentGrid = (rows: ContentGridRow[]): string => {
  return encodeURIComponent(JSON.stringify(rows));
};

export const deserializeContentGrid = (value: string): ContentGridRow[] => {
  try {
    const parsed = JSON.parse(decodeURIComponent(value));

    if (!Array.isArray(parsed)) {
      return [];
    }

    return parsed.map((row) => ({
      id: String(row?.id ?? ""),
      date: String(row?.date ?? ""),
      platform: String(row?.platform ?? ""),
      format: String(row?.format ?? ""),
      mediaType:
        row?.mediaType === "image" ||
        row?.mediaType === "video" ||
        row?.mediaType === "link"
          ? row.mediaType
          : "none",
      mediaUrl: String(row?.mediaUrl ?? ""),
      copy: String(row?.copy ?? ""),
      comments: String(row?.comments ?? ""),
      status:
        row?.status === "approved" || row?.status === "rejected"
          ? row.status
          : "pending",
      approvalCount: Number.isFinite(Number(row?.approvalCount))
        ? Number(row.approvalCount)
        : 0,
      rejectionCount: Number.isFinite(Number(row?.rejectionCount))
        ? Number(row.rejectionCount)
        : 0,
      decisionLocked: Boolean(row?.decisionLocked),
      scheduledToCalendar: Boolean(row?.scheduledToCalendar),
      scheduledNetwork: String(row?.scheduledNetwork ?? ""),
    }));
  } catch (error) {
    return [];
  }
};
